<template>
  <div class="wave-expenses">
    <h2 class="mb-3">Wave Expenses</h2>

    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else-if="error" class="alert alert-danger">
      {{ error }}
    </div>

    <div v-else>
      <!-- Expenses Chart -->
      <div v-if="expenses.length" class="chart-container mb-4">
        <apexchart
          type="pie"
          :options="chartOptions"
          :series="series"
          height="350"
        />
      </div>

      <!-- Expenses List -->
      <div class="row">
        <div v-for="account in expenses" :key="account.id" class="col-12 col-md-6 mb-3">
          <account-card :account="account" :expanded="false" />
        </div>
        <div v-if="!expenses.length" class="col-12">
          <p class="text-muted">No expense accounts found</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import AccountCard from '@/app/components/AccountCard.vue'

const store = useStore()
const loading = ref(true)
const error = ref(null)
const accounts = ref([])

const expenses = computed(() =>
  accounts.value.filter(a => a.type?.value === 'EXPENSE' && parseFloat(a.balance) !== 0)
)

const chartOptions = computed(() => ({
  labels: expenses.value.map(e => e.name),
  chart: {
    width: '100%',
    type: 'pie'
  },
  legend: {
    position: 'bottom'
  }
}))

const series = computed(() =>
  expenses.value.map(e => parseFloat(e.balance))
)

onMounted(async () => {
  try {
    const response = await store.state.api.get('/plugins/wave/accounts')
    accounts.value = response.data.accounts || []
  } catch (err) {
    error.value = err.response?.data?.error || err.message || 'Failed to load expenses'
  } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.chart-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>
